import React from 'react';
import { CheckCircleIcon } from 'lucide-react';
export function BabyFormatSection() {
  return <section className="py-12 sm:py-16 md:py-20 bg-gradient-to-br from-baby-cream via-white to-baby-pink-light" data-id="element-89">
      <div className="max-w-6xl mx-auto px-4 sm:px-6" data-id="element-90">
        <div className="text-center mb-8 sm:mb-12 animate-fade-in-up" data-id="element-91">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-92">
            Empieza Hoy Mismo
          </h2>
          <p className="text-base sm:text-lg text-gray-600 max-w-2xl mx-auto" data-id="element-93">
            Acceso instantáneo en todos tus dispositivos
          </p>
        </div>

        {/* Hero Multi-Device Image */}
        <div className="mb-8 sm:mb-12 animate-fade-in-up" style={{
        animationDelay: '0.2s'
      }} data-id="element-94">
          <div className="relative rounded-baby-lg overflow-hidden shadow-baby-glow" data-id="element-95">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/4ymZxPD3vTPXYcS6PQzKst/10-multi-device_warm_mockup_image.png" alt="30 Recetas para Bebés disponible en celular y tablet - Descarga inmediata en PDF" className="w-full h-auto" data-id="element-96" />
          </div>
        </div>

        {/* Key Features */}
        <div className="grid sm:grid-cols-3 gap-6 sm:gap-8 stagger-children" data-id="element-97">
          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-blue-light shadow-baby-soft text-center" data-id="element-98">
            <div className="w-14 h-14 bg-baby-gradient-blue rounded-full flex items-center justify-center mx-auto mb-4 shadow-baby-soft" data-id="element-99">
              <span className="text-2xl" data-id="element-100">📱</span>
            </div>
            <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-2" data-id="element-101">
              En tu celular
            </h3>
            <p className="text-sm sm:text-base text-gray-700" data-id="element-102">
              Consulta mientras cocinas, sin necesidad de internet
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-pink-light shadow-baby-soft text-center" data-id="element-103">
            <div className="w-14 h-14 bg-baby-gradient-pink rounded-full flex items-center justify-center mx-auto mb-4 shadow-baby-pink" data-id="element-104">
              <span className="text-2xl" data-id="element-105">💻</span>
            </div>
            <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-2" data-id="element-106">
              En tu tablet o computadora
            </h3>
            <p className="text-sm sm:text-base text-gray-700" data-id="element-107">
              Pantalla grande para ver mejor los pasos
            </p>
          </div>

          <div className="bg-white/90 backdrop-blur-baby p-6 sm:p-8 rounded-baby-lg border-2 border-baby-blue-light shadow-baby-soft text-center" data-id="element-108">
            <div className="w-14 h-14 bg-baby-gradient-blue rounded-full flex items-center justify-center mx-auto mb-4 shadow-baby-soft" data-id="element-109">
              <span className="text-2xl" data-id="element-110">🖨️</span>
            </div>
            <h3 className="font-bold text-base sm:text-lg text-gray-900 mb-2" data-id="element-111">
              Imprime tus favoritas
            </h3>
            <p className="text-sm sm:text-base text-gray-700" data-id="element-112">
              Pega en la nevera las recetas que más uses
            </p>
          </div>
        </div>

        {/* Bottom CTA */}
        <div className="mt-8 sm:mt-12 text-center animate-fade-in-up" style={{
        animationDelay: '0.4s'
      }} data-id="element-113">
          <div className="inline-block bg-gradient-to-br from-baby-blue-light to-baby-pink-light p-6 sm:p-8 rounded-baby-lg border-2 border-baby-lavender shadow-baby-glow" data-id="element-114">
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-6 mb-4" data-id="element-115">
              <div className="flex items-center gap-2" data-id="element-116">
                <CheckCircleIcon className="w-5 h-5 text-baby-blue" data-id="element-117" />
                <span className="text-sm sm:text-base font-semibold text-gray-800" data-id="element-118">
                  Descarga Inmediata
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-119">
                <CheckCircleIcon className="w-5 h-5 text-baby-pink" data-id="element-120" />
                <span className="text-sm sm:text-base font-semibold text-gray-800" data-id="element-121">
                  Formato PDF
                </span>
              </div>
              <div className="flex items-center gap-2" data-id="element-122">
                <CheckCircleIcon className="w-5 h-5 text-baby-blue" data-id="element-123" />
                <span className="text-sm sm:text-base font-semibold text-gray-800" data-id="element-124">
                  Sin Suscripción
                </span>
              </div>
            </div>
            <p className="text-lg sm:text-xl font-bold text-gray-900" data-id="element-125">
              Compra una vez, úsalo para siempre
            </p>
          </div>
        </div>
      </div>
    </section>;
}